import * as types from '@/store/types';

export default {
  [types.STATE_CHAT](state){
    state.stateChat = null;
  },
  [types.STATE_CALL](state, stateCall){
    state.stateCall = stateCall;
  }
};
